import {useHistory} from 'react-router';

type preventProductTilesSwipeAnimationType =
  | {preventProductTilesSwipeAnimation?: boolean}
  | undefined;

export const usePreventProductTilesSwipeAnimation = () => {
  const {location} = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const isCpnQUeryParamsPresent = searchParams.has('cpn');

  const preventProductTilesSwipeAnimation = (
    location.state as preventProductTilesSwipeAnimationType
  )?.preventProductTilesSwipeAnimation;
  return Boolean(preventProductTilesSwipeAnimation) || isCpnQUeryParamsPresent;
};

export const useHistoryReplaceWithSwipePrevention = () => {
  const history = useHistory();

  return (url: string) => {
    const [pathname, search] = url.split('?');
    const searchParams = new URLSearchParams(search);

    const linkTo: {
      state: preventProductTilesSwipeAnimationType;
      pathname?: string;
      search?: string;
    } = {
      pathname,
      search: searchParams.toString(),
      state: {
        preventProductTilesSwipeAnimation: true,
      },
    };

    history.replace(linkTo);
  };
};
